export const modernAchievementFrame = () => ({
  id: 'modern-achievement-frame',
  name: 'Modern Achievement Frame',
  thumbnail: '/assets/diploma-templates/08_frame.webp',
  data: {
    elements: [],
    backgroundColor: '#ffffff',
    backgroundImage: {
      url: '/assets/diploma-templates/backgrounds/08_background.svg',
      key: null
    }
  }
});
